import type { RendersUserModal } from "./types";

declare global {
  interface Window {
    __rootErrorBoundary: RendersUserModal | undefined;
  }
}

export const getRootErrorBoundary = (): RendersUserModal | undefined => {
  return window.__rootErrorBoundary;
};
